import Routes from 'routes';
import ThemeCustomization from 'themes';

import TelegramStartHandler from 'components/TelegramStartHandler';
import Locales from 'components/Locales';
import ScrollTop from 'components/ScrollTop';
import Snackbar from 'components/@extended/Snackbar';
import Notistack from 'components/third-party/Notistack';

import { JWTProvider as AuthProvider } from 'contexts/JWTContext';

import { TonConnectUIProvider } from '@tonconnect/ui-react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== //

const manifestUrl = `${process.env.REACT_APP_API_URL}/tonconnect-manifest.json`;
const queryClient = new QueryClient();

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <Locales>
        <ScrollTop>
          <AuthProvider>
            <ThemeCustomization>
              <TonConnectUIProvider manifestUrl={manifestUrl}>
                <Notistack>
                  <TelegramStartHandler />
                  <Routes />
                  <Snackbar />
                </Notistack>
              </TonConnectUIProvider>
            </ThemeCustomization>
          </AuthProvider>
        </ScrollTop>
      </Locales>
    </QueryClientProvider>
  );
};

export default App;
